module.exports = require("./ms-BN.d.ts");